import {
  Button,
  createStyles,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  WithStyles,
  withStyles,
  Divider,
  Typography,
  MenuItem,
  ListItemText,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  Box,
  Avatar,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import * as React from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { colors, getMomentDate } from "../constants/constants";
import Autocomplete from "@material-ui/lab/Autocomplete";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddLicenseDetailsDialog from "./AddLicenseDetailsDialog";
import LicenseIcon from "@material-ui/icons/Payment";
import AuthorisedIcon from "@material-ui/icons/EmojiTransportation";
import GenericDialog from "./GenericDialog";
import { AuthConsumer } from "../routes/AuthContext";
export const types = {
  DIALOG_INFO: "DIALOG_INFO",
  DIALOG_ACTION: "DIALOG_ACTION",
};
const styles = () =>
  createStyles({
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff",
    },
  });

const equipments = [
  { name: "Trucks", subtitle: "8 Wheel trucks" },
  { name: "Vehicle", subtitle: "4 Wheel cars" },
  { name: "Front Loader nzjdngsj nsjkdngsj", subtitle: "Big loader" },
];
const addEmployeeValidationSchema = Yup.object().shape({
  fullName: Yup.string().required("Full name is required"),
  employeeNumber: Yup.string().required("Employee number is required"),
  position: Yup.string().required("Select your position"),
  licenseNumbers: Yup.array().notRequired(),
  authorizeEquipments: Yup.array().notRequired(),
});

interface Props extends WithStyles<typeof styles> {
  title: any;
  open: any;
  employees: any;
  handleClose: any;
  editData: any;
  company: any;
  handleOnSubmit: any;
}

class AddEmployeDialog extends React.Component<Props> {
  state = {
    showPassword: false,
    hasError: false,
    selectedDate: new Date(),
    licenseDetails: Array<any>(),
    selectedLicenseDetailItem: { licenseNumber: "" },
    selectedIndex: -1,
    openAddLicenseDetailDialog: false,
    openConfirmationDialog: false,
    detailsToRemove: { index: -1 },
  };
  componentDidMount = () => {
    const { editData } = this.props;
    if (editData && editData.fullName) {
      this.setState({
        licenseDetails: editData.licenseDetails,
      });
    } else {
      this.setState({
        licenseDetails: [],
      });
    }
  };

  componentDidUpdate(prevProps: any, prevState: any) {
    const { editData } = this.props;
    if (prevProps.editData !== editData) {
      if (editData && editData.fullName) {
        this.setState({
          licenseDetails: editData.licenseDetails,
        });
      } else {
        this.setState({
          licenseDetails: [],
        });
      }
    }
  }

  handleDateChange = (item: any, index: any, date: any, setFieldValue: any) => {
    let licenseDetailsList = this.state.licenseDetails;
    licenseDetailsList[index].date = date;
    item.date = date;
    this.setState({
      licenseDetails: licenseDetailsList,
    });
    setFieldValue("licenseDetails", licenseDetailsList);
  };
  handleLicenseOnTextChanged = (
    event: any,
    item: any,
    index: any,
    setFieldValue: any
  ) => {
    let licenseDetailsList = this.state.licenseDetails;
    licenseDetailsList[index].licenseNumber = event.target.value;
    item.licenseNumber = event.target.value;
    this.setState({
      licenseDetails: licenseDetailsList,
    });
    setFieldValue("licenseDetails", licenseDetailsList);
  };

  handleOnAuoSelectItemSelected = (id: any, value: any, setFieldValue: any) => {
    setFieldValue(id, value);
  };

  handleOnAddMoreLicenseDetails = () => {
    this.setState({
      openAddLicenseDetailDialog: true,
      selectedLicenseDetailItem: {},
    });
  };

  handleOnRemoveLicenseDetail = (event: any, item: any, index: any) => {
    this.setState({
      openConfirmationDialog: true,
      detailsToRemove: { index: index },
    });
  };
  handleOnEditLicenseDetail = (event: any, item: any, index: any) => {
    let licenseDetailsList = this.state.licenseDetails;
    let selected = licenseDetailsList[index];
    this.setState({
      openAddLicenseDetailDialog: true,
      selectedIndex: index,
      selectedLicenseDetailItem: selected,
    });
  };
  handleOnEmployeeSelected = (
    event: any,
    value: any,
    id: any,
    setFieldValue: any
  ) => {
    setFieldValue(id, value);
  };

  renderAutoSelect = (
    type: String,
    id: any,
    value: any,
    handleChange: any,
    handleBlur: any,
    name: any,
    label: any,
    error: any,
    errors: any,
    setFieldValue: any,
    selections?: any
  ) => {
    return (
      <Autocomplete
        multiple
        id={id}
        freeSolo
        options={selections}
        defaultValue={
          this.props.editData && this.props.editData.fullName
            ? this.props.editData.authorizeEquipments
            : []
        }
        onChange={(event: any, value: any) =>
          this.handleOnEmployeeSelected(event, value, id, setFieldValue)
        }
        renderOption={(option: any) => (
          <React.Fragment>
            <ListItemText primary={option.name} secondary={option.subtitle} />
          </React.Fragment>
        )}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            margin="normal"
            variant="outlined"
            placeholder={"Add Authorized Equipments"}
            style={{ width: "100%" }}
          />
        )}
      />
    );
  };

  renderTextInput = (
    type: String,
    id: any,
    value: any,
    handleChange: any,
    handleBlur: any,
    name: any,
    label: any,
    error: any,
    selections?: any,
    maxLength?: any
  ) => {
    return (
      <div>
        {type === "text" && (
          <TextField
            style={{ margin: 10 }}
            id={id}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            name={name}
            label={label}
            inputProps={{ maxLength: maxLength }}
            fullWidth
          />
        )}
        {type === "select" && (
          <TextField
            style={{ margin: 10 }}
            select
            id={id}
            label={label}
            margin="dense"
            value={value ? value : ""}
            onChange={handleChange(id)}
            fullWidth
          >
            {selections.map((option: any) => {
              return (
                <MenuItem key={option.value} value={option.label}>
                  {option.label}
                </MenuItem>
              );
            })}
          </TextField>
        )}
        <Typography
          variant={"subtitle1"}
          align={"right"}
          style={{
            color: "red",
            alignSelf: "right",
          }}
        >
          {error}
        </Typography>
      </div>
    );
  };
  renderAllInputField = (
    values: any,
    handleChange: any,
    handleBlur: any,
    errors: any,
    touched: any,
    setFieldValue: any,
    licenseDetails: any,
    equipments: any
  ) => {
    const { classes, company } = this.props;
    let contractors =
      this.props.company && this.props.company.contractors
        ? this.props.company.contractors
        : new Array<any>();
    let contractorsArray = [...contractors];
    let randomId = Math.floor(Math.random() * (1000 - 1) + 1);
    contractorsArray.push({ contractType: randomId, name: company.name });
    return (
      <div>
        {this.renderTextInput(
          "text",
          "fullName",
          values.fullName,
          handleChange,
          handleBlur,
          "fullName",
          "Full Name",
          errors.fullName
        )}
        {this.renderTextInput(
          "text",
          "employeeNumber",
          values.employeeNumber,
          handleChange,
          handleBlur,
          "employeeNumber",
          "Employee Number",
          errors.employeeNumber
        )}

        <TextField
          style={{ margin: 10 }}
          select
          id={"companyName"}
          label={"Company Name"}
          margin="dense"
          value={values.companyName ? values.companyName : ""}
          onChange={handleChange("companyName")}
          fullWidth
        >
          {contractorsArray.map((option: any, index: any) => (
            <MenuItem key={`${option.name}-index-${index}`} value={option.name}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>

        {this.renderTextInput(
          "text",
          "contactNumber",
          values.contactNumber,
          handleChange,
          handleBlur,
          "contactNumber",
          "Contact Number",
          errors.contactNumber,
          [],
          10
        )}

        {this.renderTextInput(
          "text",
          "emailAddress",
          values.emailAddress,
          handleChange,
          handleBlur,
          "emailAddress",
          "Email Address",
          errors.emailAddress
        )}

        <FormControlLabel
          label="Passport Number"
          control={
            <Checkbox
              style={{ marginLeft: 5 }}
              id={"passportDocument"}
              name={"passportDocument"}
              checked={values.passportDocument}
              onChange={(event: any) => {
                setFieldValue("passportDocument", event.target.checked);
              }}
              value="Passport Number"
            />
          }
        />
        {!values.passportDocument &&
          this.renderTextInput(
            "text",
            "identityNumber",
            values.identityNumber,
            handleChange,
            handleBlur,
            "identityNumber",
            "Identity Number",
            errors.identityNumber,
            null,
            13
          )}
        {values.passportDocument &&
          this.renderTextInput(
            "text",
            "passportNumber",
            values.passportNumber,
            handleChange,
            handleBlur,
            "passportNumber",
            "Passport Number",
            errors.passportNumber
          )}
        {this.renderTextInput(
          "select",
          "position",
          values.position,
          handleChange,
          handleBlur,
          "position",
          "Position",
          errors.position,
          this.props.company && this.props.company.positions
            ? this.props.company.positions
            : new Array<any>()
        )}

        {
          <div>
            <Autocomplete
              id={"department"}
              freeSolo
              options={
                this.props.company && this.props.company.departments
                  ? this.props.company.departments
                  : new Array<any>()
              }
              value={values.department}
              onChange={(event: any, value: any) =>
                this.handleOnAuoSelectItemSelected(
                  "department",
                  value,
                  setFieldValue
                )
              }
              getOptionLabel={(option: any) =>
                option && option.title ? option.title : ""
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Department"
                  margin="normal"
                  variant="outlined"
                  placeholder={"Search department"}
                  style={{ width: "100%" }}
                />
              )}
            />
            <Typography
              variant={"subtitle1"}
              align={"right"}
              style={{
                color: "red",
                alignSelf: "right",
              }}
            >
              {errors.department}
            </Typography>
          </div>
        }
        {this.props.company &&
          this.props.company.sections &&
          this.props.company.sections.length > 0 && (
            <div>
              <Autocomplete
                id={"section"}
                freeSolo
                options={
                  this.props.company && this.props.company.sections
                    ? this.props.company.sections
                    : new Array<any>()
                }
                value={values.section}
                onChange={(event: any, value: any) =>
                  this.handleOnAuoSelectItemSelected(
                    "section",
                    value,
                    setFieldValue
                  )
                }
                getOptionLabel={(option: any) => {
                  return option && option.title ? option.title : "";
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Section"
                    margin="normal"
                    variant="outlined"
                    placeholder={"Search section"}
                    style={{ width: "100%" }}
                  />
                )}
              />
              <Typography
                variant={"subtitle1"}
                align={"right"}
                style={{
                  color: "red",
                  alignSelf: "right",
                }}
              >
                {errors.section}
              </Typography>
            </div>
          )}
        {
          <Box
            padding={1}
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ListItemText
              style={{ margin: 10, fontWeight: "bold" }}
              primary="License Details (Optional)"
            />
            <Button
              variant="outlined"
              color="secondary"
              style={{
                margin: 10,
                alignSelf: "right",
              }}
              startIcon={<AddIcon />}
              onClick={() => this.handleOnAddMoreLicenseDetails()}
            >
              Add License
            </Button>
          </Box>
        }
        <Divider style={{ height: 2, backgroundColor: "orange" }} />
        {licenseDetails && (
          <List>
            {licenseDetails.map((item: any, index: any) => (
              <div key={index.toString()}>
                <ListItem key={index.toString()}>
                  <Grid container spacing={3}>
                    <Grid item xs={6}>
                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar className={classes.avatar}>
                            {<LicenseIcon />}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={`License Number:`}
                          secondary={`Issued: ${getMomentDate(
                            item.issuedDate
                          )}`}
                        />
                        <ListItemText
                          style={{ marginLeft: 12 }}
                          primary={item.licenseNumber}
                          secondary={`Expiry: ${getMomentDate(
                            item.expiryDate
                          )}`}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={6}>
                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <ListItemAvatar>
                          <Avatar className={classes.avatar}>
                            {<AuthorisedIcon />}
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          primary={`Authorized equipment: ${item.authorizedEquipment.label}`}
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid item xs={1} container justify={"flex-end"} spacing={2}>
                    <IconButton
                      aria-label="delete"
                      size="small"
                      onClick={(event: any) =>
                        this.handleOnRemoveLicenseDetail(event, item, index)
                      }
                    >
                      <DeleteIcon fontSize="inherit" />
                    </IconButton>
                    <IconButton
                      aria-label="delete"
                      size="small"
                      style={{ marginLeft: 5 }}
                      onClick={(event: any) =>
                        this.handleOnEditLicenseDetail(event, item, index)
                      }
                    >
                      <EditIcon fontSize="inherit" />
                    </IconButton>
                  </Grid>
                </ListItem>
                <Divider />
              </div>
            ))}
          </List>
        )}
      </div>
    );
  };
  handleOnEditSubmit = (values: any) => {
    this.handleClose();
    if (this.state.selectedIndex > -1 && this.state.selectedLicenseDetailItem) {
      let licenseDetailsList = this.state.licenseDetails;
      licenseDetailsList[this.state.selectedIndex] = values;
      this.setState({
        licenseDetailsList: licenseDetailsList,
        selectedIndex: -1,
        selectedLicenseDetailItem: {},
      });
    }
  };
  handleOnSubmit = (values: any) => {
    this.handleClose();
    let licenseDetailsList = this.state.licenseDetails;
    licenseDetailsList.push(values);
    this.setState({
      licenseDetails: licenseDetailsList,
    });
  };

  handleOnAddEmployeeSubmit = (values: any, user: any, accessRules: any) => {
    const { handleOnSubmit } = this.props;
    values.licenseDetails = this.state.licenseDetails;
    if (values.passportDocument) {
      values.identityNumber = "";
    } else {
      values.passportNumber = "";
    }
    handleOnSubmit(values, user, accessRules);
  };

  handleConfirmedDelete = () => {
    let licenseDetailsList = this.state.licenseDetails;
    if (this.state.detailsToRemove && this.state.detailsToRemove.index > -1) {
      licenseDetailsList.splice(this.state.detailsToRemove.index, 1);
      this.setState({
        licenseDetails: licenseDetailsList,
        openConfirmationDialog: false,
      });
    }
  };

  handleClose = () => {
    this.setState({
      openAddLicenseDetailDialog: false,
      openConfirmationDialog: false,
    });
  };
  renderAddLicenseDetailsDialig = () => {
    let machinineryTypes = this.props.company.machinineryTypes;
    return (
      <AddLicenseDetailsDialog
        dialogTitle={"Add License"}
        open={this.state.openAddLicenseDetailDialog}
        handleOnSubmit={
          this.state.selectedLicenseDetailItem &&
          this.state.selectedLicenseDetailItem.licenseNumber
            ? this.handleOnEditSubmit
            : this.handleOnSubmit
        }
        selections={machinineryTypes ? machinineryTypes : []}
        editData={this.state.selectedLicenseDetailItem}
        onClose={this.handleClose}
      />
    );
  };

  renderConfirmationDialog = () => {
    let detatil = this.state.licenseDetails[this.state.detailsToRemove.index];
    return (
      <GenericDialog
        type={types.DIALOG_INFO}
        title={`Deleting ${
          detatil && detatil.licenseNumber ? detatil.licenseNumber : ""
        }`}
        message={"Are you sure want to delete this license item"}
        leftButtonName={"Cancel"}
        rightButtonName={"YES"}
        open={this.state.openConfirmationDialog}
        onCancel={() => this.handleClose()}
        onOk={() => this.handleConfirmedDelete()}
        handleClose={() => this.handleClose()}
      />
    );
  };

  renderForm = (
    values: any,
    handleChange: any,
    handleBlur: any,
    errors: any,
    isValid: any,
    touched: any,
    setFieldValue: any
  ) => {
    const { handleClose } = this.props;
    return (
      <Form>
        <div>
          {this.renderAllInputField(
            values,
            handleChange,
            handleBlur,
            errors,
            touched,
            setFieldValue,
            this.state.licenseDetails,
            equipments
          )}
          <DialogActions>
            <Button
              onClick={() => {
                handleClose();
              }}
            >
              {"CANCEL"}
            </Button>
            <Button type="submit" disabled={!isValid}>
              {"SUBMIT"}
            </Button>
          </DialogActions>
        </div>
      </Form>
    );
  };

  render() {
    const { open, handleClose } = this.props;
    return (
      <React.Fragment>
        <AuthConsumer>
          {({ user, accessRules }) => (
            <div>
              <Dialog
                open={open}
                keepMounted={true}
                onClose={() => handleClose()}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                fullWidth={true}
                maxWidth={"md"}
              >
                <DialogTitle id="alert-dialog-slide-title">
                  {"Adding Employees"}
                </DialogTitle>
                <Divider />
                <DialogContent>
                  <Formik
                    initialValues={
                      this.props.editData && this.props.editData.fullName
                        ? this.props.editData
                        : {
                            fullName: "",
                            employeeNumber: "",
                            companyName: "",
                            contactNumber: "",
                            emailAddress: "",
                            position: "",
                            passportDocument: false,
                            identityNumber: "",
                            passportNumber: "",
                            licenseDetails: [],
                            department: "",
                            section: "",
                          }
                    }
                    enableReinitialize={true}
                    validationSchema={addEmployeeValidationSchema}
                    onSubmit={(values) => {}}
                  >
                    {({
                      values,
                      handleChange,
                      handleBlur,
                      handleReset,
                      handleSubmit,
                      errors,
                      isValid,
                      touched,
                      setFieldValue,
                    }) => (
                      <div>
                        {this.renderAllInputField(
                          values,
                          handleChange,
                          handleBlur,
                          errors,
                          touched,
                          setFieldValue,
                          this.state.licenseDetails,
                          equipments
                        )}
                        <DialogActions>
                          <Button
                            onClick={() => {
                              handleReset();
                              handleClose();
                            }}
                          >
                            {"CANCEL"}
                          </Button>
                          <Button
                            type="submit"
                            disabled={!isValid}
                            onClick={() => {
                              this.handleOnAddEmployeeSubmit(
                                values,
                                user,
                                accessRules
                              );
                              handleReset();
                            }}
                          >
                            {"SUBMIT"}
                          </Button>
                        </DialogActions>
                      </div>
                    )}
                  </Formik>
                </DialogContent>
              </Dialog>
            </div>
          )}
        </AuthConsumer>
        {this.renderAddLicenseDetailsDialig()}
        {this.renderConfirmationDialog()}
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(AddEmployeDialog);
